import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getPfxData (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCertificate)
    })
  } else {
    const req = {
      url: '/api/certificados/getpfxdata',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getPfxData }
